import * as D3Array from 'd3-array'

export function yDomain(props, stack, horizonal) {
  const {
    data,
    chartSeries,
    y,
    yDomain,
    yScale
  } = props;

  if(yDomain)
    return yDomain;

  if(!horizonal) {
    if(stack) {
      // stack
      let max = 0;
      let min = 0;

      data.forEach((d) => {
        let totalTop = 0;
        let totalBottom = 0;

        chartSeries.forEach((sd) => {
          let field = sd.field;

          if(d[field] > 0) {
            totalTop += y(d[field]);
          }else if (d[field] < 0) {
            totalBottom += y(d[field]);
          }
        })

        if(totalTop > max) max = totalTop;
        if(totalBottom < min) min = totalBottom;
      })

      return [min, max];
    }else {
      // not stack, single
      let domainArr = chartSeries.map((d) => {
        let field = d.field;
        let extent = D3Array.extent(data, (dt) => { return y(dt[field]); });

        return extent;
      })

      let extentArr = D3Array.extent([].concat.apply([], domainArr))

      if(extentArr[0] * extentArr[1] >= 0) {
        return [0, extentArr[1]]
      }else {
        return extentArr
      }
    }
  }else {
    if(yScale === 'ordinal') {
      return data.map((d) => { return y(d); });
    }else {
      return D3Array.extent(data, (d) => { return y(d); });
    }
  }
}
